import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { SharedComponent } from './shared/shared.component';
import { AuthguardGuard } from './shared/authguard.guard'
const routes: Routes = [ {
    path:'main',component:SharedComponent,
    canActivate: [AuthguardGuard],
    children: [
      {
        path: "rides/ride-detail",
        loadChildren: () => import('./ride-detail/ride-detail.module').then(m => m.RideDetailModule),
      },
      {
        path: "rentals",
        loadChildren: () => import('./rentals/rentals.module').then(m => m.RentalsModule),
      },
      {
        path: "settlement-rides",
        loadChildren: () => import('./settlement-rides/ride-history.module').then(m => m.SettlementRidesModule),
      },
      {
    path: 'dashboard',
    loadChildren: () =>
      import('./dashboard/dashboard.module').then(
        (m) => m.DashboardModule
        ),
  },
  {
    path: '',
    canActivate: [AuthguardGuard],
    loadChildren: () =>
      import('./rental-vehicle/rental-vehicle.module').then(
        (m) => m.RentalVehicleModule
      ),
  },
  {
    path:'dynamic',
    loadChildren:()=>
    import('./viewcustomer/viewcustomer.module').then(
      (m)=>m.ViewcustomerModule
    ),
      },
{
path:'link',
loadChildren:()=>
import('./map/map.module').then(
  (m)=>m.MapModule
),
},
{
  path:'promo-codes',
  loadChildren:()=>
  import('./promocodelist/promocodelist.module').then((m)=>m.PromocodelistModule),
},
{path:'promo-codes/create-promocode',
loadChildren:()=>
import('./create-promocode/create-promocode.module').then((m)=>m.CreatePromocodeModule)
},
      {
        path:'customer/edit',
        loadChildren:()=>
        import('./editcustomer/editcustomer.module').then(
          (m)=>m.EditcustomerModule
        ),
      },
  {
    path:'polygon',
    loadChildren:()=>
    import('./geofencing/geofncing.module').then(
      (m)=>m.GeofncingModule
    )
  },
  {
    path:'sub-region',
    loadChildren:()=>
    import('./sub-region/sub-region.module').then(
      (m)=>m.SubRegionModule
    )
  },
  {
    path:'sub-region/list',
    loadChildren:()=>
    import('./sub-region-list/sub-region-list.module').then(
      (m)=>m.SubRegionListModule
    )
  },
  {
path:'promotion',
loadChildren:()=>
import('./promotion/promotion.module').then((m)=>m.PromotionModule),
  },
  {
    path:'chat',
    loadChildren:()=>
    import('./help/help.module').then(
      (m)=>m.HelpModule
    )
  },
  {
    path:'polygon/create-polygon',
    loadChildren:() =>
    import('./polygon/polygon.module').then(
      (m)=>m.PolygonModule
    )
  },
  {
    path:'vehicletype',
    loadChildren:() =>
    import('./vehicle/vehicle.module').then(
      (m)=>m.VehicleModule
    )
  },
  //  {
  //   path:'create-polygon',
  //   loadChildren:() =>
  //   import('./map/map.module').then(
  //     (m)=>m.MapModule
  //   )
  // },
  {
    path:'settlements',
    loadChildren:() =>
    import('./settlement/settlement.module').then(
      (m)=>m.SettlementModule
    )
  }, {
    path:'Settlement/viewsettlment',
    loadChildren:() =>
    import('./viewdriversettlement/viewdriversettlement.module').then(
      (m)=>m.ViewdriversettlementModule
    )
  },

  {
    path:'SubAdmin',
    loadChildren:()=>
    import('./subadmin/subadmin.module').then(
      (m)=>m.SubadminModule
    ),
  },
  {
    path:'SubAdmin/create-subadmin',
    loadChildren:()=>
    import('./create-admin/create-admin.module').then(
      (m)=>m.CreateAdminModule
    ),
  },
  {
     path: 'create-promocode',
     loadChildren:()=>
      import('./create-promocode/create-promocode.module').then(
        (m)=>m.CreatePromocodeModule
      ),
  },
  {
path:'Notification',
loadChildren:()=>
import('./notifucation/notifucation.module').then(
  (m)=>m.NotifucationModule
),
  },
  {
  path:'location',
loadChildren:()=>
import('./driverlocation/driverlocation.module').then(
  (m)=>m.DriverlocationModule
),

},
{
  path:'ridelocation',
  loadChildren:()=>
  import('./rideloaction/ridelocation.module').then((m)=>m.RidelocationModule),
},
  {
  path: 'customer',
  loadChildren: () =>
  import('./customer-list/customer-list.module').then(
    (m) => m.CustomerListModule),
},
{
  path: 'rides',
  loadChildren: () =>
  import('./rides-history/ride-history.module').then(
    (m) => m.RideListModule),
},
{
  path: 'completed-rides',
  loadChildren: () =>
  import('./rides-history/ride-history.module').then(
    (m) => m.RideListModule),
},
{
  path: 'ongoing-rides',
  loadChildren: () =>
  import('./rides-history/ride-history.module').then(
    (m) => m.RideListModule),
},
{
  path: 'cancelled-rides',
  loadChildren: () =>
  import('./rides-history/ride-history.module').then(
    (m) => m.RideListModule),
},
  {
    path:'driverlist',
    loadChildren:() =>
    import('./driverlist/driverlist.module').then(
      (m) =>m.DriverlistModule
    ),
  },
  {
    path: 'reason',
    loadChildren:() =>
      import('./consumer-issues/consumer-issues.module').then(
        (m) =>m.IssuesModule
      ),
  },
  {
    path:'Cancel',
    loadChildren:() =>
    import('./cancelletion/cancelletion.module').then(
      (m) => m.CancelletionModule
    ),
  },
  {
    path:'settings',
    loadChildren:() =>
import('./settings/settings.module').then(
  (m) =>m.SettingsModule
),
  },
  {
    path:'driverlist/create-driver',
    loadChildren:() =>
    import('./create-driver/create-driver.module').then(
      (m) =>m.CreateDriverModule
    ),
  },
  {
    path:'driverlist/view-driver',
    loadChildren:() =>
    import('./create-driver/create-driver.module').then(
      (m) =>m.CreateDriverModule
    ),
  },
  ]
},

  {
    path: 'login',
    loadChildren: () =>
      import('./components/login-module/login-module.module').then(
        (m) => m.LoginModuleModule
      ),
  },

  {
    path: 'otp',
    loadChildren: () =>
      import('./components/otp/otp.module').then(
        (m) => m.OtpModule
      ),
  },
  {
    path: 'resetpassword',
    loadChildren: () =>
      import('./components/reset-password/reset-password.module').then(
        (m) => m.ResetPasswordModule
      ),
  },

  {
    path: 'CNFRMPassword',
    loadChildren: () =>
      import('./components/confirm-reset-password/confirm-reset-password.module').then(
        (m) => m.ConfirmResetPasswordModule
      ),
  },

  {
    path: "privacy-policy",
    loadChildren: () => import('src/app/privacy-policy/privacy-policy.module').then(m => m.PrivacyPolicyModule)
  },
  {
    path: "terms",
    loadChildren: () => import('src/app/terms-and-conditions/terms-and-conditions.module').then(m => m.TermsAndConditionsModule)
  },

  {
    path: '**',
    redirectTo: '/login',
    pathMatch: 'full',
  },
];
@NgModule({
  imports: [RouterModule.forRoot(routes,{
    scrollPositionRestoration: 'enabled'}
    )],
  exports: [RouterModule]
})
export class AppRoutingModule { }
